import React, { ReactNode } from 'react';

export const getTextFromReactNode = (node: React.ReactNode): string => {
  if (typeof node === 'string') {
    return node;
  }

  if (React.isValidElement(node)) {
    const children = React.Children.toArray(node.props.children);

    return children.map((child) => getTextFromReactNode(child)).join('');
  }

  return '';
};

export const reactNodeContains = (
  node: ReactNode | string,
  search: string,
): boolean => {
  return getTextFromReactNode(node)
    .toLowerCase()
    .includes(search.toLowerCase());
};
